import React, { FC } from 'react';
import { formatDate } from 'utils/format';
import { Box, Typography } from '@mui/material';
import { currentUserVar } from 'apollo/reactive-variables/user';
import { ChatMessage } from 'models/chat-messages';

type ChatMessageContentProps = {
    chatMessage: ChatMessage;
};

const ChatMessageContent: FC<ChatMessageContentProps> = ({ chatMessage }: ChatMessageContentProps) => {
    const currentUser = currentUserVar();
    const isSentByCurrentUser = () => {
        return currentUser._id === chatMessage.sender;
    };

    return (
        <Box
            display="flex"
            sx={
                !chatMessage.isRead && !isSentByCurrentUser()
                    ? { padding: '8px', bgcolor: 'calm.light', borderRadius: 5 }
                    : {}
            }
            justifyContent={isSentByCurrentUser() ? 'flex-end' : 'flex-start'}
            mb={2}
        >
            <Box flex="0 1 auto" sx={{ maxWidth: '90%' }}>
                <Box
                    px={1}
                    py={0.5}
                    sx={{
                        bgcolor: currentUser._id === chatMessage.sender ? 'calm.dark' : 'grey.800',
                        color: '#fff',
                        borderRadius: 2,
                    }}
                >
                    <Typography variant="body2" dangerouslySetInnerHTML={{ __html: chatMessage.message }}></Typography>
                </Box>
                <Box mr={1}>
                    <Typography variant="caption">
                        {chatMessage.senderName} {formatDate(chatMessage.createdAt, 'datetime')}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};
export default ChatMessageContent;
